import "./index.css";

interface SubtitleProps {
  text: string;
  type: TemplateType;
  style?: React.CSSProperties;
}

const Subtitle = (props: SubtitleProps) => {
  const { text, style = {}, type = "main" } = props;

  const formatText = (text: string) => ({ __html: text.replace(/\n/g, "<br>") });

  return <div className={`base-subtitle base-subtitle-${type}`} style={style} dangerouslySetInnerHTML={formatText(text)} />;
};

export default Subtitle;
